import {
  setShowErrorAlert,
  setShowErrorAlertMessage,
} from "@features";
import { customUseEffect } from "@pionglobal/pionsharedui";
import { useDispatch } from "react-redux";

function ErrorNotifier(props) {
  const dispatch = useDispatch();
  customUseEffect(() => {
    dispatch(setShowErrorAlert(true));
    dispatch(setShowErrorAlertMessage(props?.message));
  }, []);

  return (
    <></>
    // <div className="error-notification-box">
    //   <span className="error-notification">
    //     <i className="material-icons">error</i>
    //     {props.message}
    //   </span>
    // </div>
  );
}
export default ErrorNotifier;
